import { EGeoSuggestStatus, GeoSuggestDependencies, IGeoSuggestResult } from './types';
import { fetchSuggest, ISuggestRequest, TSuggestResponse } from '../../repositories/geo-suggest/v2/suggest';
import { ResponseError } from 'shared/errors';
import { prepareGeoSuggest } from 'shared/mappers/prepareGeoSuggest';

export const getGeoSuggestions = async (
  dependencies: GeoSuggestDependencies,
  parameters: ISuggestRequest,
): Promise<IGeoSuggestResult> => {
  const { httpApi, logger } = dependencies;

  try {
    const { statusCode, response }: TSuggestResponse = await fetchSuggest({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'critical.geoSuggest',
        message: response.message || 'geoSuggest error',
        details: {
          error: JSON.stringify(response.errors),
        },
      });
    }

    return prepareGeoSuggest(response);
  } catch (error) {
    logger.warning(
      { ...error, domain: 'critical.geoSuggest' },
      {
        degradation: 'Запрос гео-саджестов',
        details: {
          microserviceName: 'geo-suggest',
          pathApi: '/public/v2/suggest/',
          parameters: JSON.stringify(parameters),
        },
      },
    );

    return {
      data: {
        suggestions: {},
        sortOrder: [],
      },
      message: 'geo-suggest /v2/suggest/ rejection error',
      status: EGeoSuggestStatus.CriticalError,
    };
  }
};
